import { Serializable } from '../../../../core/serializable';


export class RequestField extends Serializable {

    

    get trackingId(): number {
        return this._trackingId;
    }


    get consigneeName(): string {
        return this._consigneeName;
    }

   
    get countryName(): string {
        return this._countryName;
    }
    get createdAt(): string {
        return this.getFormattedDate(new Date(this._createdAt.toLocaleString()));
   }

    private getFormattedDate(dateValuetobeFormatted: Date): string {
        var monthValue = dateValuetobeFormatted.getMonth() + 1;
        var dateValue = dateValuetobeFormatted.getDate();
        var yearValue = dateValuetobeFormatted.getFullYear();
        return monthValue + "/" + dateValue + "/" + yearValue;
    }


    get transportMode(): string {
        return this._transportMode;
    }


    get icon(): string {
        if (!this._transportMode)
            return '';

        if (this._transportMode.toUpperCase().toString().trim() === 'LTL')
            return 'airport_shuttle';
        else if (this._transportMode.toUpperCase().toString().trim() === 'TRUCK')
            return 'local_shipping';
        else if (this._transportMode.toUpperCase().toString().trim() === 'OCEAN')
            return 'directions_boat';
        else if (this._transportMode.toUpperCase().toString().trim() === 'AIR')
            return 'flight';
        else if (this._transportMode.toUpperCase().toString().trim() === 'EXPRESS')
            return 'star';
        else if (this._transportMode.toUpperCase().toString().trim() === 'EXPRESS OR LTL')
            return 'star';
        return '';
    }

    

    constructor(private _trackingId?: number,
        private _consigneeName?: string,
        private _countryName?: string,
        private _createdAt ?: Date,
        private _transportMode ?: string
        ) {
        super();
    }
    
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/models/RequestField.ts
 **/